import React from "react";
import { DateFormatter } from "@/library/components/formatters/DateTimeFormatters";
import Link from "next/link";
import TagDefault from "../tags/TagDefault";

export default function NewsListItem({ item }) {
  return (
    <div>
      <Link
        href={`/news/${item.newsId}`}
        key={item.newsId}
        className="flex flex-col gap-y-3 md:px-12"
      >
        <p className="text-xs font-semibold mt-8 md:mt-0">
          <DateFormatter dateTimeString={item.publishDate} />
        </p>
        <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-textOrange line-clamp-3">
          {item.title}
        </h2>
        {/* {item.teaser && (
          <div
            className="text-sm line-clamp-3 font-thin"
            dangerouslySetInnerHTML={{ __html: item.teaser }}
          ></div>
        )} */}
        <div className="flex flex-col gap-y-1">
          {item.regulatory && (
            <TagDefault
              text={"Regulatory Information"}
              color={"bg-color-dark"}
            />
          )}
          <TagDefault text={item.categoryName} color={"bg-color-orange"} />
        </div>
      </Link>
    </div>
  );
}
